import { render } from "./invoiceView.vue?vue&type=template&id=b6ce02fa"
import script from "./invoiceView.vue?vue&type=script&lang=js"
export * from "./invoiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__